module.exports = __webpack_public_path__ + "img/works_img20022504.96abe35c.jpg";